export const azureMarketplaceFields: Record<
  string,
  { label: string; fieldType: string; displayOrder: number; category: string }
> = {
  Labra__MSFT_Billing_Account_ID__c: {
    label: 'Billing Account ID',
    fieldType: 'Number',
    displayOrder: 1,
    category: 'Fields',
  },
  Labra__Company_Name__c: {
    label: 'Company Name',
    fieldType: 'Text',
    displayOrder: 2,
    category: 'Fields',
  },
  Labra__Custom_Email_Message__c: {
    label: 'Custom Email Message',
    fieldType: 'Text',
    displayOrder: 3,
    category: 'Fields',
  },
  Labra__EULA_Type__c: {
    label: 'EULA Type',
    fieldType: 'Picklist',
    displayOrder: 4,
    category: 'Fields',
  },
  Labra__Offer_Expiration_Date__c: {
    label: 'Offer Expiration Date',
    fieldType: 'Date',
    displayOrder: 5,
    category: 'Fields',
  },
  Labra__Offer_Name__c: {
    label: 'Offer Name',
    fieldType: 'Text',
    displayOrder: 6,
    category: 'Fields',
  },
  Labra__Renewal_Type__c: {
    label: 'Renewal Type',
    fieldType: 'Picklist',
    displayOrder: 7,
    category: 'Fields',
  },
  Labra__EULA_Attachment__c: {
    label: 'EULA',
    fieldType: 'File',
    displayOrder: 8,
    category: 'Fields',
  },
  Labra__Metadata_Hide__c: {
    label: 'Metadata',
    fieldType: 'Boolean',
    displayOrder: 9,
    category: 'Metadata',
  },
  Labra__Stakeholders__c: {
    label: 'Stakeholders',
    fieldType: 'Boolean',
    displayOrder: 10,
    category: 'Metadata',
  },
}
